import {ILogger, LogLevel} from "@amplitude/analytics-core";

/*** This logger is overriding the default Amplitude logger to remove warnings and logs in the browser ***/
export class AmplitudeLogger implements ILogger {
  disable(): void {}

  enable(logLevel: LogLevel): void {}

  log(...args: any[]): void {}

  warn(...args: any[]): void {}

  error(...args: any[]): void {
    console.log(...args);
  }

  debug(...args: any[]): void {}
}
